import { Logo, type LogoProps } from '@alison/ui';
import { useTenant } from '@alison/whitelabel/react';
import type { ReactNode } from 'react';

/** Logo that follows the white-label tenant; Alison keeps the built-in SVGs. */
export function TenantLogo(props: LogoProps): ReactNode {
  const tenant = useTenant();
  if (tenant.isAlison) return <Logo {...props} />;
  const src = props.variant === 'glyph' ? tenant.icon : tenant.logo;
  return <Logo {...props} src={src} alt={tenant.providerName} />;
}
